
<div class="w-fit flex flex-col items-centered shrink-0 relative group">
  <img *ngIf="imgUrl" class="rounded-full border " [class]="classes" [src]="imgUrl">

  <div *ngIf="!imgUrl" class="rounded-full border bg-slate-700 flex flex-row justify-center items-center" [class]="classes">
    <h4 [class]="initialsClass" >{{initials}}</h4>
  </div>

  <div *ngIf="imgUrl && canFlag" class="hidden group-hover:block absolute right-0 bottom-0 rounded-full bg-slate-800 text-white p-1 text-xs cursor-pointer" (click)="flag()">
    <fa-icon icon="flag"></fa-icon>
  </div>

</div>


